export enum TemplateStatus {
    Draft = 1,
    Completed = 2
}
